import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../common/Header";
import Footer from "../common/Footer";
import Hero from "./Hero";
import Intro from "./Intro";
import Features from "./Features";
import SecurityDocuments from "./SecurityDocuments";
import PageWrapper from "../common/PageWrapper";
import "./Landing.css";

const Landing = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const scrollToSection = () => {
      if (location.hash) {
        const sectionId = location.hash.replace("#", ""); // Supprime le '#' de l'ancre
        const section = document.getElementById(sectionId);
        const offset = 25; // Définir un offset fixe ici (par exemple, 100px)

        if (section) {
          const elementPosition = section.offsetTop;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        } else {
          // Réessayer après un court délai si l'élément n'est pas encore disponible
          setTimeout(scrollToSection, 100);
        }
      }
    };

    scrollToSection();
  }, [location]);

  return (
    <div className="landing-wrapper">
      <Header onMenuToggle={setIsMenuOpen} />
      <PageWrapper isMenuOpen={isMenuOpen}>
        <main className="landing-content">
          <section id="intro">
            <Intro />
          </section>
          <section id="hero">
            <Hero />
          </section>
          <section id="features">
            <Features />
          </section>
          <section id="security-documents">
            <SecurityDocuments />
          </section>
        </main>
      </PageWrapper>
      <Footer />
    </div>
  );
};

export default Landing;
